import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {PearlHarbor} from "../PearlHarbor";
import {PearlHarborGameData} from "../server/PearlHarborData";
import {PearlHarborGameMode} from "../server/PearlHarborGameMode";
import {TimelineLite} from "gsap";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";

export class PearlHarborWinCapPresentation implements SimplePresentationRunner {

    private _mainTL:TimelineLite;
    private _controller:SimplePresentationRunnerController;

    shouldRun():boolean {
        const gameData:PearlHarborGameData = PearlHarbor.model.gameData;
        if(gameData.brokeBank && (gameData.nextMode != PearlHarborGameMode.NORMAL)) {
            throw Error("next mode is not normal when win max win.");
            debugger;
        }
        return gameData.brokeBank;
    }

    start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        this._mainTL = new TimelineLite();
        this._mainTL.add(() => {
            if(!PearlHarbor.model.isNormal) {
                if(PearlHarbor.model.dogfight.kamakazi) {
                    PearlHarborSoundManager.playFSEndSoundFromKamakaziToWinCap();
                } else {
                    PearlHarborSoundManager.playFSEndSound();
                }
            }
        });
        this._mainTL.add(() => {
            PearlHarbor.winCapView.playWinCapAnimations(() => this.complete());
        });
    }

    public complete():void {
        this._controller.finish();
    }
}